var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      ref: "newPopover",
      attrs: {
        title: _vm.form.id ? "修改" : "新增",
        visible: _vm.dialogShow,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogShow = $event
        },
        close: function($event) {
          return _vm.clearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "140px" }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "名称", prop: "name" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入名称" },
                model: {
                  value: _vm.form.name,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "语言", prop: "language" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.form.language,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "language", $$v)
                    },
                    expression: "form.language"
                  }
                },
                _vm._l(_vm.language, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "平台类型", prop: "platform_type" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    multiple: "",
                    "collapse-tags": "",
                    placeholder: "请选择"
                  },
                  model: {
                    value: _vm.form.platform_type,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "platform_type", $$v)
                    },
                    expression: "form.platform_type"
                  }
                },
                _vm._l(_vm.platformTypeList, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "是否为支付官网", prop: "type" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.form.type,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "type", $$v)
                    },
                    expression: "form.type"
                  }
                },
                _vm._l(_vm.typeList, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "自定义标识", prop: "custom_text" } },
            [
              _c(
                "div",
                {
                  staticClass: "x-je",
                  attrs: { slot: "label" },
                  slot: "label"
                },
                [
                  _c("div", [_vm._v("自定义标识(选填)")]),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "dark",
                        content: "pc ",
                        placement: "top-start"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { "line-height": "18px" },
                          attrs: { slot: "content" },
                          slot: "content"
                        },
                        [
                          _vm._v(" pc : PC下载地址(固定最右侧)"),
                          _c("br"),
                          _vm._v(" yy : 预约按钮(点击出现预约弹窗)"),
                          _c("br"),
                          _vm._v(" tap : taptap预约按钮"),
                          _c("br")
                        ]
                      ),
                      _c("i", { staticClass: "el-icon-question" })
                    ]
                  )
                ],
                1
              ),
              _c("el-input", {
                attrs: { clearable: "", placeholder: "输入左侧提示内容指定值" },
                model: {
                  value: _vm.form.custom_text,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "custom_text", $$v)
                  },
                  expression: "form.custom_text"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "状态", prop: "is_open" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.is_open,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "is_open", $$v)
                    },
                    expression: "form.is_open"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 1, border: "" } }, [
                    _vm._v("已开放")
                  ]),
                  _c("el-radio", { attrs: { label: 0, border: "" } }, [
                    _vm._v("未开放")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { width: "100%" } },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addDomain } },
                [_vm._v("添加链接")]
              )
            ],
            1
          ),
          _vm._l(_vm.form.url, function(domain, index) {
            return _c(
              "div",
              {
                key: index + "r",
                staticClass: "lodingItemT",
                staticStyle: { display: "flex", width: "100%" }
              },
              [
                _c(
                  "div",
                  { staticClass: "y-start ", staticStyle: { width: "100%" } },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { width: "100% !important" },
                        attrs: {
                          prop: "url." + index + ".url",
                          label: "跳转链接(选填)"
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            clearable: "",
                            placeholder: "请输入跳转链接"
                          },
                          model: {
                            value: domain.url,
                            callback: function($$v) {
                              _vm.$set(domain, "url", $$v)
                            },
                            expression: "domain.url"
                          }
                        }),
                        _c("el-button", {
                          staticStyle: { "margin-left": "10px" },
                          attrs: {
                            size: "mini",
                            type: "danger",
                            circle: "",
                            icon: "el-icon-delete"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.removeDomain(domain)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { label: "图标", prop: "url." + index + ".img" }
                      },
                      [
                        _c("uploadImage", {
                          attrs: { value: domain.picfileList },
                          on: {
                            input: function($event) {
                              return _vm.imgChangeT($event, domain, index)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          }),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "100% !important" },
              attrs: { label: "二维码(选填)", prop: "qr_code" }
            },
            [
              _c("uploadImage", {
                attrs: { value: _vm.qr_code },
                on: {
                  input: function($event) {
                    return _vm.imgChange($event, "qr_code")
                  }
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "100% !important" },
              attrs: { label: "图片", prop: "show_img" }
            },
            [
              _c("uploadImage", {
                attrs: { value: _vm.show_img },
                on: {
                  input: function($event) {
                    return _vm.imgChange($event, "show_img")
                  }
                }
              })
            ],
            1
          )
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  return _vm.hide()
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "info" },
              on: {
                click: function($event) {
                  return _vm.clearData(true)
                }
              }
            },
            [_vm._v("重置")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.submitData()
                }
              }
            },
            [_vm._v("提交")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }